export function NWAAdBug() {
  return (
    <span className="flex h-6 w-[27px] items-center justify-center rounded-[0.25rem] bg-[var(--content-blue)]/25 text-black">
      <span className="typography-text-extra-small text-center">AD</span>
    </span>
  );
}
